import {IHttpService} from "angular";
import {AccountId} from "../../types/AccountRecord";

export class SimulatedAccountService {

    public static readonly id = "simulatedAccountService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async reset(id: AccountId): Promise<void> {
        const url = `/tradefloor/api/portfolio/${id}/reset`;
        await this.$http.post<void>(url, null);
    }
}
